import React, { FC, useState } from 'react'
import { CellularPayPrompt } from './types'
import { Banner } from './banner'
import { PromptButton } from './dialog-parts'
import { shutOffMessage } from './sim-status'

// A shut-off is final, so once the customer has read it they need not see it
// again for that bill. Kept per invoice: a later bill's shut-off is news again.
const KEY_PREFIX = 'cellularPayPrompt.shutOffDismissed.'

const isDismissed = (invoiceId: string): boolean => {
  try {
    return window.localStorage.getItem(`${KEY_PREFIX}${invoiceId}`) === '1'
  } catch (error) {
    return false
  }
}

const rememberDismissed = (invoiceId: string): void => {
  try {
    window.localStorage.setItem(`${KEY_PREFIX}${invoiceId}`, '1')
  } catch (error) {
    // Storage can be unavailable; the banner just comes back on the next load.
  }
}

// Every SIM on the bill is shut off for good: nothing to pay, nothing locked, and
// the same for the owner and for anyone working in their workspace.
export const ShutOffBanner: FC<{ prompt: CellularPayPrompt }> = ({ prompt }) => {
  const [dismissed, setDismissed] = useState(() => isDismissed(prompt.invoiceId))
  if (dismissed) return null

  const dismiss = () => {
    rememberDismissed(prompt.invoiceId)
    setDismissed(true)
  }

  return (
    <Banner
      message={shutOffMessage(prompt)}
      tone='destructive'
    >
      <PromptButton
        onClick={dismiss}
        variant='textPrimary'
      >
        Dismiss
      </PromptButton>
    </Banner>
  )
}
